import React, { MouseEvent, useContext } from 'react'
import { useNavigate, Link } from 'react-router-dom';

import { MediaQueryContext } from '@arrive/responsive-provider';
import { LOAD_DETAIL_PATH, ROUTES } from 'constants/routeConstants';
import { CANT_CONFIRM_SPECIALTIES, BOOK_SUCCESS, BOOK_FAILURE, LOCK_EXPIRED, CAN_BOOK, BOOK_LOCK_FAILURE, TENDER_SUCCESS } from 'constants/bookingConstants';
import { LoadType } from 'sharedTypes/loads/loadType';
import { modifyWithPersistURLEnv } from 'helpers/urlHelpers';
import Button from '@arrive/button'
import { BookItNowContactRep } from 'components/ContactRepSection/ContactRepSection';
import { CommonModalFooterWrapper } from 'components/CommonModalComponents/CommonModalComponents';

import styles from './BookingModal.scss'

interface Props {
  handleBookItNow: () => void;
  handleRequestLock: () => void;
  closeModal: () => void;
  binStatus: string;
  loadNumber: number;
  isLoadBoard: boolean;
  load: LoadType;
  handleSpecialRecsContact: (event: MouseEvent<HTMLAnchorElement>) => void;
  isMAO: boolean;
  handleSubmitOffer?: () => void;
  wasLoadBooked: boolean;
}

export default function BookingModalFooter({ handleBookItNow, handleRequestLock, closeModal, binStatus, loadNumber, isLoadBoard, load, handleSpecialRecsContact, isMAO, handleSubmitOffer, wasLoadBooked }: Props) {
  const currentMediaTypes = useContext(MediaQueryContext);
  const navigate = useNavigate()

  const showClose = binStatus === CANT_CONFIRM_SPECIALTIES || binStatus === BOOK_SUCCESS || binStatus === BOOK_FAILURE || binStatus === BOOK_LOCK_FAILURE || binStatus === TENDER_SUCCESS;
  const showRetryOrBinButton = binStatus !== CANT_CONFIRM_SPECIALTIES && binStatus !== BOOK_SUCCESS && binStatus !== TENDER_SUCCESS && binStatus !== LOCK_EXPIRED && binStatus !== BOOK_LOCK_FAILURE;
  const closeModalInLoadDetails = binStatus === BOOK_SUCCESS && !isLoadBoard && !isMAO;
  const binButtonActionText = isMAO ? 'Send Offer' : 'Book It Now';

  const buttonSize = currentMediaTypes.sm ? 'md' : 'lg';
  return (
    <CommonModalFooterWrapper>
      <Button size={buttonSize}
        data-testid="bookingModalCancelButton"
        type='secondary'
        onClick={closeModal}
        text={true}
      >
        {showClose ? "Close" : "Cancel"}
      </Button>
      {showRetryOrBinButton &&
        <Button
          data-testid="bookingModalBookButton"
          className={styles.binButton}
          size={buttonSize}
          disabled={binStatus !== CAN_BOOK && binStatus !== BOOK_FAILURE}
          onClick={isMAO ? handleSubmitOffer : handleBookItNow}
        >
          {binStatus === BOOK_FAILURE ? 'Retry' : binButtonActionText}
        </Button>}
      {binStatus === CANT_CONFIRM_SPECIALTIES &&
        <Button
          className={styles.binButton}
          size={buttonSize}
          onClick={() => {
            closeModal();
            if (!isLoadBoard) {
              navigate(ROUTES.loadBoard);
            }
          }}
        >
          Find Loads
        </Button>
      }
      {(binStatus === BOOK_SUCCESS || binStatus === TENDER_SUCCESS) && isLoadBoard && !isMAO &&
        <Link to={modifyWithPersistURLEnv(`/${LOAD_DETAIL_PATH}/${loadNumber}`)}>
          <Button size={buttonSize} onClick={() => {
            closeModal();
          }} >View Load</Button>
        </Link>}
      {binStatus === BOOK_SUCCESS && isMAO &&
        <Button
          className={styles.binButton}
          size={buttonSize}
          onClick={() => {
            closeModal();
            navigate(ROUTES.myOffers);
          }}
        >
          My Offers
        </Button>
      }
      {closeModalInLoadDetails &&
        <Button
          className={styles.binButton}
          size={buttonSize}
          onClick={closeModal}>
          Done
        </Button>
      }
      {binStatus === LOCK_EXPIRED && !wasLoadBooked &&
        <Button
          size={buttonSize}
          onClick={handleRequestLock}>
          Try Again
        </Button>
      }
      {binStatus === BOOK_LOCK_FAILURE &&
        <BookItNowContactRep
          onClick={handleSpecialRecsContact}
          btnSize={buttonSize}
          theme='ethanol'
          type='primary'
          load={load}
        />
      }
    </CommonModalFooterWrapper>
  )
}
